module.exports = __webpack_public_path__ + "static/media/mounted.8bbc6284.png";